import { createContext } from "react";

const countryContext = createContext();

export default countryContext;
